import { AdherentService } from '../../adherent.service';
import { FournisseurService } from '../../fournisseur.service';
import { SnackbarService } from '../../snackbar/snackbar.service';
import { StorageService } from '../../storage.service';

export const servicesProviders = [
  AdherentService,
  StorageService,
  FournisseurService,
  SnackbarService,
];
